// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IRailwaySchema {
  /** Список ID направлений **/
  directionIds?: number[];
  /** Расстояние до станции **/
  distance?: number;
  /** ID ЖД-станции **/
  id?: number;
  /** Название станции **/
  name?: string;
  /** Время до станции **/
  time?: number;
  /** Способ передвижения до ЖД **/
  travelType?: ETravelType;
}
export enum ETravelType {
  /** На машине **/
  'ByCar' = 'byCar',
  /** Пешком **/
  'ByFoot' = 'byFoot',
}
